import React, { useState, useRef, useEffect, useCallback } from 'react';
import bannerData from '../../Data/Banner.json'; // Adjust the import path as needed
import { Helmet } from 'react-helmet-async';

// Carousel Component
const Carousel = ({ items }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const carouselInnerRef = useRef(null);
  const intervalRef = useRef(null);

  // Move to the next item
  const nextSlide = useCallback(() => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % items.length);
  }, [items.length]);

  // Move to the previous item
  const prevSlide = useCallback(() => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? items.length - 1 : prevIndex - 1
    );
  }, [items.length]);

  // Move to a specific slide
  const goToSlide = useCallback((index) => {
    setCurrentIndex(index);
  }, []);

  // Setup auto-scroll interval
  const setupAutoScroll = useCallback(() => {
    intervalRef.current = setInterval(nextSlide, 6000); // Change slide every 6 seconds
  }, [nextSlide]);

  // Clear auto-scroll interval
  const clearAutoScroll = useCallback(() => {
    clearInterval(intervalRef.current);
  }, []);

  useEffect(() => {
    if (carouselInnerRef.current) {
      carouselInnerRef.current.style.transform = `translateX(-${currentIndex * 100}%)`;
    }
  }, [currentIndex]);

  useEffect(() => {
    setupAutoScroll();

    // Clear interval on component unmount
    return () => clearAutoScroll();
  }, [setupAutoScroll, clearAutoScroll]);

  // Handle user interaction
  const handleMouseEnter = () => {
    clearAutoScroll();
  };

  const handleMouseLeave = () => {
    setupAutoScroll();
  };

  return (
    <div
      className="carousel"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <button className="carousel-control prev" onClick={prevSlide}>
        &#10094;
      </button>
      <div className="carousel-wrapper">
        <div className="carousel-inner" ref={carouselInnerRef}>
          {items.map((item, index) => (
            <div key={index} className="carousel-item">
              <a href={item.link} className="carousel-link">
                <img src={item.image} alt={`Highlight ${index + 1}`} width={795} height={400}/>
              </a>
            </div>
          ))}
        </div>
      </div>
      <button className="carousel-control next" onClick={nextSlide}>
        &#10095;
      </button>
      <ul className="carousel-dots">
        {items.map((_, index) => (
          <li
            key={index}
            className={`carousel-dot ${currentIndex === index ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
          ></li>
        ))}
      </ul>
    </div>
  );
};

// Home Component
const Home = () => {
  const [shuffledSubHighlights, setShuffledSubHighlights] = useState([]);

  // Shuffle the subHighlights array and pick 2 random items
  const shuffleSubHighlights = () => {
    const shuffled = [...bannerData.bannerData.subHighlights]
      .sort(() => 0.5 - Math.random())
      .slice(0, 2);
    setShuffledSubHighlights(shuffled);
  };

  useEffect(() => {
    shuffleSubHighlights();
  }, []);

  return (
    
    <>
    <Helmet>
      
    <meta name="robots" content="index, follow"></meta>
    <meta name="robots" content="INDEX, FOLLOW"></meta>
      <title>Home - Affilizone</title>
      <meta name="description" content="Discover top deals and curated finds at AffiliZone Philippines. Browse online with exclusive affiliate offers to help make your next big purchase!"/>
      
      <link rel="canonical" href="https://affilizone-d16ba.web.app/"/>
      <meta property="og:title" content="AffiliZone Philippines"/>
    <meta property="og:site_name" content="AffiliZone Philippines"/>
    <meta property="og:type" content="website"/>
    <meta property="og:url" content="https://affilizone-d16ba.web.app/"/>
    <meta property="og:image" content="https://affilizone-d16ba.web.app/logo512.png"/>
    <meta property="og:image:type" content="image/png"/>
    <meta property="og:image:height" content="512"/>
    <meta property="og:image:width" content="512"/>
    <meta property="og:description" content="Elevate Your Shopping with Curated Picks from AffiliZone"/>
    <meta name="twitter:card" content="summary_large_image"/>
    <meta name="twitter:title" content="Affilizone Philippines"/>
    <meta name="twitter:description" content="Elevate Your Shopping with Curated Picks from AffiliZone"/>
    <meta name="twitter:image" content="https://affilizone-d16ba.web.app/logo512.png/"/>
    </Helmet>
    <div className="affilizone-Content">
      <div className="home-page">
        <div className="container">
          <div className="Banner">
            <div className="content-wrapper">
              {/* Main Feature Content */}
              <div className="main-content">
                <Carousel items={bannerData.bannerData.highlights} />
              </div>
              {/* Two Stacked Images */}
              <div className="stacked-content">
                {shuffledSubHighlights.map((item, index) => (
                  <div key={index} className="stacked-image">
                    <a href={item.link} className="carousel-link">
                      <img src={item.image} alt={`Sub Highlight ${index + 1}`} width={397.5} height={196.25} />
                    </a>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Home;
